var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.classesCount},[_vm._v(_vm._s(_vm.count))]),_c('button',{on:{"click":_vm.sub}},[_vm._v("-")]),_c('button',{on:{"click":_vm.add}},[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }